import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

/**
 * `app-cesion-portal` en un diálogo, para las pantallas que ofrecían ceder desde un botón
 * («Continuar cediendo» de `continuar-operacion`). Al cerrar devuelve `true` si algo cambió.
 */
@Component({
  selector: 'app-cesion-portal-dialog',
  // Cabecera de los diálogos del portal (`que_es_un_aec`, `detalle-facturas`): `close-dialog`
  // arriba a la derecha (global, styles.scss), `titulo-simpli` + `subtitulo-simpli`.
  template: `
    <div mat-dialog-title>
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="position: relative;margin-top: 20px;">
        <div class="close-dialog" (click)="cerrar()" role="button" aria-label="Cerrar">
          <span class="material-symbols-outlined">close</span>
        </div>
        <h1 class="titulo-simpli">Cesión de tus facturas</h1>
        <small class="subtitulo-simpli">Cede tus facturas a Simpli en el SII. Puedes seguir el estado de cada una aquí.</small>
      </div>
    </div>
    <mat-dialog-content class="cp-dialogo-contenido">
      <app-cesion-portal [id_sim]="id_sim" [id_company]="id_company" (cambio)="huboCambios = true"></app-cesion-portal>
    </mat-dialog-content>
  `,
  styles: [`
    .cp-dialogo-contenido { max-height: 75vh; }
    @media (max-width: 1024px) {
      .cp-dialogo-contenido { max-height: none; }
    }
  `],
  standalone: false,
})
export class CesionPortalDialog {
  id_sim: any;
  id_company: any = localStorage.getItem('company_id');
  huboCambios = false;

  constructor(private dialogRef: MatDialogRef<CesionPortalDialog>) {}

  cerrar(): void {
    this.dialogRef.close(this.huboCambios);
  }
}
